var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolCapture = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8.644 8.556a1.9 1.9 0 0 0 1.109-.432l1.853-1.692c.314-.26.702-.41 1.109-.432h2.903c.403.023.788.175 1.099.432l1.853 1.692c.314.259.702.41 1.109.432h3.427a2.135 2.135 0 0 1 1.917 2.149v8.712a1.917 1.917 0 0 1-1.917 1.916H5.216A1.917 1.917 0 0 1 3.3 19.417v-8.712a2.135 2.135 0 0 1 1.917-2.15z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.161,
  cy: 13.986,
  r: 3.514,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M21.828 11.43a.32.32 0 1 1 0 .64.32.32 0 0 1 0-.64"
}))));
export { SvgToolCapture as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-capture.svg";